import React from "react";

import { Divider } from "@busbud/horizon";

interface Props {
  className?: string;
  noDivider?: boolean;
  title?: string;
  children?: React.ReactNode;
}

export const FooterItem: React.FC<Props> = ({
  children,
  className,
  noDivider = false
}) => {
  const with_divider = !noDivider;
  return (
    <div className={className}>
      {!!children && <div className="px-200 py-300 sm:p-0">{children}</div>}
      {with_divider ? <Divider className="-mr-200 sm:hidden" /> : null}
    </div>
  );
};
